import { Component, Input } from '@angular/core';
import { FEExperience } from '@shared/models/fe-experience.model';

@Component({
  selector: 'ess-experience-modal-card',
  templateUrl: './experience-modal-card.component.html',
  styleUrls: ['./experience-modal-card.component.scss'],
  standalone: false,
})
export class ExperienceModalCardComponent {
  @Input() experience: FEExperience | null = null;
}
